var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 61,
    height: 61,
    rx: 30.5,
    fill: "url(#paint0_linear_61_7119)",
    stroke: "url(#paint1_linear_61_7119)",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 27.5789C17.5 21.945 19.7019 18.2274 22.5513 15.89C25.4519 13.5106 29.1043 12.5 32 12.5C34.9802 12.5 38.6202 13.2781 41.4796 15.5002C44.2722 17.6705 46.5 21.355 46.5 27.5789C46.5 32.2283 44.2344 37.0576 41.1535 41.3619C38.2227 45.4563 34.6698 48.914 32.0382 51.06C29.3918 48.7358 25.8135 45.0745 22.8622 40.9077C19.7534 36.5185 17.5 31.7908 17.5 27.5789ZM32 9.5C28.4957 9.5 24.1481 10.6999 20.6487 13.5705C17.0981 16.4831 14.5 21.055 14.5 27.5789C14.5 32.7388 17.1981 38.1011 20.4141 42.6417C23.6605 47.2251 27.5979 51.1981 30.4174 53.6262C31.3125 54.397 32.6271 54.4292 33.5578 53.6882C36.3948 51.4296 40.3414 47.6506 43.5929 43.108C46.8259 38.5914 49.5 33.141 49.5 27.5789C49.5 20.5397 46.9278 15.9348 43.3204 13.1314C39.7798 10.3798 35.4198 9.5 32 9.5ZM37 27C37 29.7614 34.7614 32 32 32C29.2386 32 27 29.7614 27 27C27 24.2386 29.2386 22 32 22C34.7614 22 37 24.2386 37 27ZM40 27C40 31.4183 36.4183 35 32 35C27.5817 35 24 31.4183 24 27C24 22.5817 27.5817 19 32 19C36.4183 19 40 22.5817 40 27Z",
    fill: "url(#paint2_linear_61_7119)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_7119",
    x1: 56.96,
    y1: 0.00000108547,
    x2: -6.34387,
    y2: 28.1671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04B6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E75FD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_61_7119",
    x1: 13.44,
    y1: -3.58094e-8,
    x2: 7.13874,
    y2: 61.1063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_61_7119",
    x1: 21.85,
    y1: 9.5,
    x2: 16.2603,
    y2: 51.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.a7b77e507d9be5d01d5015afb60ab5c4.svg";
export { ForwardRef as ReactComponent };